/* hys-ansi-clearance.js
 * Product-page behaviour for the ANSI-Only clearance callout.
 * - Injects a "-30%" pill onto the ANSI-Only certification button.
 * - Toggles the callout between "prompt" (CSA+ANSI selected) and
 *   "confirm" (ANSI-Only selected) as the shopper changes certification.
 * - Shows the callout + pill only while the ANSI-Only variant matching
 *   the selected frame colour exists AND is in stock. Selection is read
 *   straight from the picker radios on every change (the theme's
 *   on:variant:change event is unreliable: updateVariantInput can throw
 *   on a null gallery slider before the dispatch line) and matched
 *   against the variants JSON Venue embeds inside <variant-radios>.
 *   Initial visibility is server-rendered by the snippet (hidden
 *   attribute), so there is no flash.
 * The discount itself is a Shopify automatic discount applied at checkout;
 * this only surfaces it. Markup is rendered by snippets/hys-ansi-clearance.liquid.
 */
(function () {
  if (window.__hysAnsiClearanceInit) return;
  window.__hysAnsiClearanceInit = true;

  function escapeName(name) {
    return window.CSS && CSS.escape ? CSS.escape(name) : name;
  }

  function initEl(el) {
    if (el.__hysInit) return;
    el.__hysInit = true;

    var certOption = el.getAttribute('data-cert-option') || 'Certification';
    var certIndex = parseInt(el.getAttribute('data-cert-index') || '0', 10);
    var ansiValue = el.getAttribute('data-ansi-value') || 'ANSI-Only';
    var pillText = el.getAttribute('data-pill-text') || '';
    var callout = el.querySelector('.hys-ansi-clearance__callout');

    // Scope to the surrounding product section so a quick-shop card for a
    // different product can't hijack this product's certification radios.
    var scope = el.closest('section') || el.closest('[data-section]') || document;
    var selector = 'input[name="' + escapeName(certOption) + '"]';

    // Variant data + change events come from the Venue picker component
    // the callout now renders inside of.
    var host = el.closest('variant-radios, variant-selects, variant-mixed-inputs');
    var variants = null;
    if (host) {
      // Venue 18 embeds two JSON scripts (single "variant-data" first,
      // "all-variant-data" array second); Venue 12 embeds one unnamed
      // array. Prefer the explicit all-variants script when present.
      var dataScript = host.querySelector('script[id^="all-variant-data"]')
        || host.querySelector('script[type="application/json"]');
      if (dataScript) {
        try {
          variants = JSON.parse(dataScript.textContent);
        } catch (err) {
          variants = null;
        }
      }
      if (!Array.isArray(variants)) variants = null;
    }

    function ansiChecked() {
      var inputs = scope.querySelectorAll(selector);
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) return inputs[i].value === ansiValue;
      }
      return false;
    }

    function syncState() {
      if (callout) callout.setAttribute('data-state', ansiChecked() ? 'confirm' : 'prompt');
    }

    function addPill() {
      if (!pillText) return;
      var inputs = scope.querySelectorAll(selector);
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value !== ansiValue) continue;
        var item = inputs[i].closest('.product-form__swatch__item');
        if (!item || item.querySelector('.hys-ansi-clearance-pill')) continue;
        item.classList.add('hys-ansi-clearance-has-pill');
        var pill = document.createElement('span');
        pill.className = 'hys-ansi-clearance-pill';
        pill.setAttribute('aria-hidden', 'true');
        pill.textContent = pillText;
        item.appendChild(pill);
      }
    }

    function setEligible(show) {
      el.hidden = !show;
      var pills = scope.querySelectorAll('.hys-ansi-clearance-pill');
      for (var i = 0; i < pills.length; i++) pills[i].hidden = !show;
    }

    // Selected value per option group, in variant.options order (radio
    // groups render in that order). Null when the picker isn't radio-based
    // or a group has no checked input — callers fail open in that case.
    function selectedOptions() {
      if (!host) return null;
      var radios = host.querySelectorAll('input[type="radio"]');
      var names = [];
      for (var i = 0; i < radios.length; i++) {
        if (names.indexOf(radios[i].name) === -1) names.push(radios[i].name);
      }
      if (!names.length) return null;
      var values = [];
      for (var k = 0; k < names.length; k++) {
        var checked = host.querySelector('input[type="radio"][name="' + escapeName(names[k]) + '"]:checked');
        if (!checked) return null;
        values.push(checked.value);
      }
      return values;
    }

    // Only promote the discount when the ANSI-Only variant for the
    // currently-selected frame colour exists and is in stock.
    function updateEligibility() {
      if (!variants) return;
      var sel = selectedOptions();
      if (!sel) return;
      var target = sel.slice();
      target[certIndex] = ansiValue;
      var sibling = null;
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        var match = opts && opts.length === target.length;
        for (var j = 0; match && j < opts.length; j++) {
          if (opts[j] !== target[j]) match = false;
        }
        if (match) {
          sibling = variants[i];
          break;
        }
      }
      setEligible(!!(sibling && sibling.available));
    }

    // Delegated listener survives the theme re-rendering price/buttons.
    scope.addEventListener('change', function (e) {
      if (e.target && e.target.name === certOption) syncState();
      updateEligibility();
    });

    addPill();
    syncState();
    // Server render decided initial visibility; align the pill with it,
    // then let the radios (which reflect any ?variant= deep link) refine.
    if (el.hidden) setEligible(false);
    updateEligibility();
  }

  function boot() {
    var els = document.querySelectorAll('hys-ansi-clearance.hys-ansi-clearance--pdp');
    for (var i = 0; i < els.length; i++) initEl(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
